import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { Mesh, Texture } from 'three';
import { getDRACOLoader } from '../utils/loaderConfig';
import { inspectAvatarRig } from '../avatar/rig';
import { avatarReadiness } from '../avatar/readiness';

export async function inspectCreatedAvatar(url: string) {
  const loader = new GLTFLoader().setDRACOLoader(getDRACOLoader()).setMeshoptDecoder(MeshoptDecoder);
  const gltf = await loader.loadAsync(url);
  try {
    return avatarReadiness(inspectAvatarRig(gltf.scene, url).manifest);
  } finally {
    // This loader owns these resources; do not dispose drei's shared cache.
    const textures = new Set<Texture>();
    gltf.scene.traverse(node => {
      const mesh = node as Mesh;
      if (!mesh.isMesh) return;
      mesh.geometry.dispose();
      for (const material of Array.isArray(mesh.material) ? mesh.material : [mesh.material]) {
        for (const value of Object.values(material)) if (value instanceof Texture) textures.add(value);
        material.dispose();
      }
    });
    textures.forEach(texture => texture.dispose());
  }
}
